var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{ref:"button",attrs:{"medium":"","icon":""},on:{"click":function($event){return _vm.$vuetify.goTo(0)}}},[_c('v-icon',{attrs:{"color":"light-purple"}},[_vm._v(" mdi-navigation ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }